<template>
    <div>
        <member-write-link v-for="writeLayout in writeLayouts" :key="`member${writeLayout}`"
                           :writeLayout="writeLayout" :memberData="memberData" :orderInfoData="orderInfoData" :memberKey="memberKey"></member-write-link>
    </div>
</template>

<script>
import memberUtil from "@/components/member/memberUtil";
import MemberWriteLink from "@/components/member/MemberWriteLink";
import MemberValidator from "@/mixins/validators/MemberValidator";
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import ApiFileUpload from "@/mixins/ApiFileUpload";
import DeleteClass from "@/mixins/deleteClass";

import {getTokenObj} from "@/mixins/Auth";

export default {
    name: "MemberWriteComponent",
    mixins: [alertMixins, memberUtil, MemberValidator, ApiFileUpload],
    components: {MemberWriteLink},
    inject: [],
    provide() {
        return {
            memberWriteSetData: this.setData,
        }
    },
    props: {
        memberType: {},
        memberKey: {default: 0},
        defaultFilter: {
            default: () => {
            }
        },
    },
    data() {
        return {
            getFunc: '',
            detailApiParamSet: {},
            getCategoryFunc: '',
            isCategory: true,
            writeFunc: '',
            writeLayouts: [],
            writeApiParamSet: {},
            memberData: {},
            isRunning: false,
            parsingData: {},
            fileInfo: [],
            directUrl: '',
            directType: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            writeFailMsg: '',
            fileUploadFailMsg: '',

            isUpdateSurvey: false,
            allSetData: false,

            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteKeyName: '',

            DeleteClass: null,

            mb_face: 1, //얼굴형
            mb_skin: 1, //피부톤
            mb_job: 2, //직종
            mb_job_extra: '', //직종이 1인경우 입력값
            mb_mat_shoulder: 1, //착용감-어깨
            mb_mat_middle: 1, //착용감-배
            mb_mat_top: 1, //착용감-가슴 (남자만)
            mb_mat_bottom: 1, //착용감-힙 (남자만)
            mb_mat_waist: 1, //착용감-허리 (여자만)
            mb_mat_thigh: 1, //착용감-허벅지 (여자만)
            mb_body: 1, //체형,

            orderInfoData: {} // 주문자 정보
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initFilterConfig();
        if (this.memberKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getMember();
            this.getMemberOrder();
        }
    },
    mounted() {
        EventBus.$on('writeMember', this.writeMember);
        EventBus.$on('writeDeleteMember', this.runDelete);
        EventBus.$on('writeGetMember', this.getMember);
        EventBus.$on('saveMember', this.writeMember);
    },
    beforeDestroy() {
        EventBus.$off('writeMember')
        EventBus.$off('writeDeleteMember');
        EventBus.$off('writeGetMember');
        EventBus.$off('saveMember')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },

        initTemplateConfig() {
            let config = this.returnMemberConfig(this.memberType);
            this.writeLayouts = config.writeLayouts;
        },

        initFilterConfig() {
            let config = this.returnMemberConfig(this.memberType);
            this.getFunc = config.getFunc;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;
            this.writeFailMsg = config.writeFailMsg;

            this.parsingData = config.parsingData;
            this.detailApiParamSet = config.detailApiParamSet;
            this.fileInfo = config.fileInfo;
            this.keyName = config.keyName;
            this.directUrl = config.directUrl;
            this.directType = config.directType;

            this.isUpdateSurvey = config.isUpdateSurvey;
            this.allSetData = config.allSetData;

            this.deleteFunc = config.deleteFunc;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;

            this.newDeleteClass();
        },

        getMember() {
            let params = Object.assign({}, this.detailApiParamSet, this.defaultFilter);
            params.no = this.memberKey;
            EventBus.$emit('changeLoading', true);
            try {
                this.$api.$member[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type !== 1 || util.isEmpty(res.List)) {
                        this.errorAlert( '데이터를 불러올 수 없습니다.');
                        this.$router.back();
                        return false;
                    }
                    this.memberData = res.List[0];
                    EventBus.$emit('changeLoading', false);
                    this.initTemplateConfig();
                })
            } catch (e) {
                console.log((e));
                EventBus.$emit('changeLoading', false);
            }
        },

        saveMember(){
            if(this.memberType == 'createMember' || this.memberType == 'updateMember'){
                this.writeMemberOrder()
            } else {
                this.writeMember()
            }
        },

        _checkValidator() {
            let validatorArr = Object.keys(this.parsingData);
            console.log(validatorArr)
            return this.$validate(validatorArr).then(success => {
                if(!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, validatorArr);
                    });
                    return success
                }
                util.Array.each(this.fileInfo, (fileInfo, index, arr) => {
                    if(success && fileInfo.required && util.isEmpty(this[fileInfo.fileName])) {
                        this.errorAlert(fileInfo.validatorMsg)
                        success = false;
                    }
                })
                return success;
            })
        },

        _makeParams () {
            let params = Object.assign({}, this.writeApiParamSet);
            util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                if(this.allSetData || this.memberData[paramKey] !== this[dataKey]) {
                    params[paramKey] = this[dataKey];
                    if(!this.isSetOrderData && (dataKey === 'order_mb_name' || dataKey === 'order_mb_hp')) {
                        delete params[paramKey];
                    }
                }
            })
            if(this.memberData.mb_sex === 1 && params.hasOwnProperty('mb_mat_top')) {
                params.mb_mat_waist = params.mb_mat_top;
                delete params.mb_mat_top;
            }
            if(this.memberData.mb_sex === 1 && params.hasOwnProperty('mb_mat_bottom')) {
                params.mb_mat_thigh = params.mb_mat_bottom;
                delete params.mb_mat_bottom;
            }

            if(this.memberKey !== 0) {
                params[this.keyName] = this.memberKey;
            }
            return params
        },

        async writeMember() {
            if (this.isRunning) {
                return false;
            }
            this.isRunning = true;

            let validator = await this._checkValidator();
            if(!validator) {
                this.isRunning = false;
                return false;
            }

            EventBus.$emit('changeLoading', true);
            let params = this._makeParams();

            try {
                this.$api.$member[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnWriteType(res.Info.Type);
                    if (type === true) {
                        let key = res.List;
                        if (this.memberKey !== 0) {
                            key = this.memberKey;
                        }
                        this.runApiUploadFiles(this.fileInfo, key).then(res => {
                            if(this.isUpdateSurvey) {
                                this.updateSurvey(key)
                            }else{
                                this.afterFunc(key);
                            }
                        })
                    }else{
                        this.errorAlert(type);
                        this.isRunning = false;
                        EventBus.$emit('changeLoading', false);
                    }
                })
            }catch (e) {
                console.log(e)
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
            }
        },

        returnWriteType(type) {
            if (type === this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? this.writeFailMsg : this.writeFailTypes[type]
            }
        },

        afterFunc() {
            if(this.directType === 'admin') {
                let token = this.$localStorage.get('token');
                let tokenObj = getTokenObj();
                if(tokenObj.hasOwnProperty('mb_no')) {
                    this.$store.dispatch('common/setUserImg', {mb_no: tokenObj.mb_no});
                }
                this.$store.dispatch('userInfo/setUserInfo', {token: token});
            }
            this.isRunning = false;
            this.createAlert({
                content: '저장하였습니다.',
                hide: () => {
                    if (this.directType === 'back') {
                        this.$router.back();
                        EventBus.$emit('changeLoading', false)
                        return false;
                    }
                    if (this.directType === 'admin') {
                        this.writeLayouts = [];
                        this.$nextTick(() => {
                            this.initTemplateConfig();
                            EventBus.$emit('changeLoading', false)
                        })
                        return false;
                    }
                    if (this.directUrl === '') {
                        this.writeLayouts = [];
                        this.getMember();
                        EventBus.$emit('changeLoading', false)
                        return false;
                    }
                    EventBus.$emit('changeLoading', false)
                    let url = this.directUrl;
                    this.$router.push(url);
                }
            })
        },

        updateSurvey(mb_no) {
            let params = {
                m_type: 'eot',
                mb_no: mb_no,
                mb_face: this.mb_face,
                mb_skin: this.mb_skin,
                mb_job: this.mb_job,
                mb_job_extra: this.mb_job_extra ? this.mb_job_extra : '',
                mb_color: this.mb_color,
                mb_part: this.mb_part,
                mb_mat_shoulder: this.mb_mat_shoulder,
                mb_mat_middle: this.mb_mat_middle,
                mb_body: this.mb_body,
                mb_is_finish: 1
            }

            if (this.mb_sex === 1) {
                params.mb_mat_waist = this.mb_mat_top;
                params.mb_mat_thigh = this.mb_mat_bottom;
            } else {
                params.mb_mat_top = this.mb_mat_top;
                params.mb_mat_bottom = this.mb_mat_bottom;
            }

            EventBus.$emit('changeLoading', true);
            try {
                this.$api.$member.updateSurvey(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type !== 1) {
                        this.errorAlert( '데이터를 변경할 수 없습니다.');
                        this.isRunning = false;
                        EventBus.$emit('changeLoading', false);
                        return false;
                    }else{
                        this.afterFunc();
                    }
                })
            } catch (e) {
                console.log(e);
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
            }
        },

        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$member[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },

        runDelete(key, value) {
            let params = {
                m_type: 'admin',
                mb_no: this.memberData.mb_no,
                // mb_password
                moc_idx: 1,
            }
            value = params;
            EventBus.$emit('changeLoading', true);
            this.DeleteClass.runDelete(key, value);
        },

        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '삭제가 완료되었습니다.',
                hide: () => {
                    this.$router.back();
                }
            })
        },


        getMemberOrder(){
          let params = {
              mb_no: this.memberKey,
          };
          EventBus.$emit('changeLoading', true)
          try {
              this.$api.$member.getMemberOrderInfo(params).then(res => res.Data.Result).then(res => {
                  if(res.Info.Type == 1){
                      EventBus.$emit('changeLoading', false )
                      if(!util.isEmpty(res.List)){
                          this.orderInfoData = res.List;
                        //   this.initTemplateConfig();
                      }else {
                          this.errorAlert('정보를 불러오지 못했습니다.')
                          this.$router.back()
                      }
                  }
              })
          } catch (e) {
              EventBus.$emit('changeLoading', false )
              console.log(e);
          }
        },

        async writeMemberOrder() {
            let validator = await this.$validate(['order_mb_name', 'order_mb_hp'] );
            if(!validator) {
                this.errorAlert('필수데이터를 확인해주세요.')
                this.isRunning = false;
                return false;
            }
            validator = await this._checkValidator();
            if(!validator) {
                this.isRunning = false;
                return false;
            }
            EventBus.$emit('changeLoading', true);
            let params = {
                m_type: 'normal',
                mb_no: this.memberKey,
                mb_name: this.order_mb_name,
                mb_hp: this.order_mb_hp
            }
            try {
                this.$api.$member.updateMemberOrderInfo(params).then(res => res.Data.Result).then(res => {
                    let type = this.returnMyInfoWriteType(res.Info.Type)
                    if (type === true) {
                        EventBus.$emit('changeLoading', false);
                        this.writeMember();
                    }else{
                        EventBus.$emit('changeLoading', false);
                        this.errorAlert(type);
                    }
                })
            }catch (e) {
                console.log(e)
                EventBus.$emit('changeLoading', false);
            }
        },

        returnMyInfoWriteType(type){
            switch (type) {
                case 1:
                    return true;
                case -100:
                    return '주문 정보를 확인해주세요.';
                case -400:
                    return '수정 대상이 아닙니다.';
                default:
                    return '주문 정보를 확인해주세요.';
            }
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
